import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-eye',
  templateUrl: './icon-eye.component.html',
  styleUrls: ['./icon-eye.component.scss']
})
export class IconEyeComponent implements OnInit {
  @Input() color = '#262628';
  @Input() size = 18;

  constructor() { }

  ngOnInit() {
  }

}
